// Select all elements with the class 'expand-btn'
const expandButtons = document.querySelectorAll('.expand-btn');

expandButtons.forEach(button => {
  button.addEventListener('click', function() {
    const expandMenu = this.parentNode.querySelector('.expand-menu');
    const iconOpen = this.querySelector('.expand-btn-icon-open');
    const iconClose = this.querySelector('.expand-btn-icon-close');

    // Toggle 'open' class on expandMenu
    expandMenu.classList.toggle('open');

    // Toggle visibility of icons
    iconOpen.style.display = iconOpen.style.display === 'none' ? 'block' : 'none';
    iconClose.style.display = iconClose.style.display === 'none' ? 'block' : 'none';
  });
});

// Select all elements with the class 'expand-item'
const expandItems = document.querySelectorAll('.expand-item');

expandItems.forEach(item => {
  item.addEventListener('click', function() {
    const variantId = this.getAttribute('data-id');
    if (!variantId) return;

    const innerTitle = this.querySelector('span');
    const innerTitleSave = innerTitle.textContent;
    const itemWidth = this.offsetWidth;

    // Add item to Shopify cart
    Shopify.addItem(this, variantId, 1);

    // Set width and change text
    this.style.width = `${itemWidth}px`;
    innerTitle.textContent = 'ADDED';

    setTimeout(() => {
      this.style.width = 'auto';
      innerTitle.textContent = innerTitleSave;
    }, 1000);
  });
});